import { Box, Typography } from '@mui/material';
import { useContext, useMemo } from 'react';

import { ConfigContext } from '@/Contexts/ConfigContext';
import { AddressProps } from '@/models/Address';
import { CountryProps } from '@/models/Country';
import { ProgramNames } from '@/models/Program';
import { StateProps } from '@/models/State';
import { getCountyByCountyId } from '@/utils/addressUtil';
import { USCountryId } from '@/utils/constants';

export default function ReadOnlyAddress({
  address,
  programId,
}: {
  address: AddressProps;
  programId: number;
}) {
  const { allCounties, allCountries, allStates } = useContext(ConfigContext);

  const stateName = useMemo(
    () =>
      address && address.stateId
        ? allStates.find((state: StateProps) => state.id === address.stateId)?.name
        : '',
    [allStates, address]
  );

  const countryName = useMemo(
    () =>
      allCountries.length > 0 && address && address.countryId
        ? allCountries.find((country: CountryProps) => country.id === address.countryId)?.name
        : '',
    [allCountries, address]
  );

  const countyName = useMemo(
    () =>
      address && address.countyId && address.stateId
        ? (getCountyByCountyId(allCounties, address.countyId, address.stateId)?.name ?? '')
        : '',
    [allCounties, address]
  );

  return (
    <Box>
      <Typography variant='overline2' component='p' sx={{ marginBottom: '4px' }}>
        Address
      </Typography>

      {address.streetAddress1 ? (
        <Typography color='textSecondary'>{address.streetAddress1}</Typography>
      ) : (
        <Typography color='error'>Street Address *</Typography>
      )}

      {address.streetAddress2 && (
        <Typography color='textSecondary'>{address.streetAddress2}</Typography>
      )}

      <Typography color='textSecondary'>
        {address.city ? address.city + ', ' : <Typography color='error'>City *</Typography>}
        {((programId == ProgramNames.TreeCitiesWorld && address?.countryId == USCountryId) ||
          programId != ProgramNames.TreeCitiesWorld) &&
          (stateName ? stateName + ' ' : <Typography color='error'>State *</Typography>)}
        {address.zipCode ? address.zipCode : <Typography color='error'>Postal Code*</Typography>}
      </Typography>

      {((programId == ProgramNames.TreeCitiesWorld && address?.countryId == USCountryId) ||
        programId != ProgramNames.TreeCitiesWorld) &&
        (countyName ? (
          <Typography color='textSecondary'>{countyName}</Typography>
        ) : (
          <Typography color='error'>County *</Typography>
        ))}

      {countryName ? (
        <Typography color='textSecondary'>{countryName}</Typography>
      ) : (
        <Typography color='error'>Country *</Typography>
      )}
    </Box>
  );
}
